import type { ChangelogEntry } from "../types";

/**
 * VIB-2575. Kunder som ikke er registrert for EHF ble avvist av PowerOffice,
 * og feilen var usynlig. Nå faller vi tilbake på e-postfaktura, og en kunde
 * uten kobling vises tydelig med en knapp for nytt forsøk.
 */
export const POWEROFFICE_KOBLING_2026_10: ChangelogEntry = {
  id: "2026-10-07-poweroffice-kobling",
  date: "2026-10-07",
  title: "Kunder uten EHF kobles til PowerOffice med e-postfaktura",
  summary:
    "Du ser nå når en kunde ikke er koblet til PowerOffice, og kan koble den med ett klikk.",
  sections: [
    {
      heading: "Kunder og fakturering",
      items: [
        {
          title: "Kunder uten EHF kommer inn i PowerOffice",
          kind: "rettet",
          minRole: "user",
          body: "PowerOffice avviste kunder som ikke kan ta imot EHF-faktura, og da kunne prosjektet ikke faktureres. Nå får slike kunder faktura på e-post i stedet. Mangler kunden e-post, eller postnummer og poststed for utenlandske kunder, får du beskjed om nøyaktig hva som må fylles ut.",
        },
        {
          title: "«Ikke koblet til PowerOffice» med knapp for nytt forsøk",
          kind: "nytt",
          minRole: "user",
          body: "Kunder som mangler kobling til PowerOffice er merket på prosjektet og kundekortet. Trykk «Koble til PowerOffice» når opplysningene er på plass. Kunden kobles, og åpne prosjekter hos kunden blir samtidig opprettet i PowerOffice, så de kan faktureres.",
        },
        {
          title: "Tydelig advarsel når et nytt prosjekt ikke kom inn i PowerOffice",
          kind: "rettet",
          minRole: "user",
          body: "Før fikk du beskjed om at prosjektet var synkronisert, også når det ikke var det. Nå får du en advarsel med grunnen, og feilen står i prosjektets hendelseslogg. Postnummer og poststed kan også redigeres under Kundeinfo i prosjektets innstillinger.",
        },
      ],
    },
  ],
};
